import React, { Component } from "react";
import { Editor } from "react-draft-wysiwyg";
import PropTypes from "prop-types";
import {
  EditorState,
  convertToRaw,
  convertFromRaw,
  ContentState,
} from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

class EmailContentEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editorState: EditorState.createEmpty(),
      lastHtml: "",
    };
    this.isInternalChange = false; // track internal user edits
  }

  componentDidMount() {
    const { initialContent } = this.props;
    if (initialContent) this.loadContent(initialContent);
  }

  componentDidUpdate(prevProps) {
    const { initialContent } = this.props;

    // ✅ Prevent resetting editor when editing (only reload if external content changes)
    if (
      initialContent &&
      initialContent !== prevProps.initialContent &&
      !this.isInternalChange &&
      initialContent !== this.state.lastHtml
    ) {
      this.loadContent(initialContent);
    }
  }

  // ✅ Load initial HTML or DraftJS raw data
  loadContent = (content) => {
    try {
      if (!content) return;

      let contentState;
      if (typeof content === "object" && content.blocks) {
        contentState = convertFromRaw(content);
      } else if (typeof content === "string") {
        const blocksFromHtml = htmlToDraft(content);
        if (blocksFromHtml) {
          const { contentBlocks, entityMap } = blocksFromHtml;
          contentState = ContentState.createFromBlockArray(
            contentBlocks,
            entityMap
          );
        }
      }

      if (contentState) {
        const editorState = EditorState.createWithContent(contentState);
        this.setState({
          editorState,
          lastHtml: this.props.initialContent || "",
        });
      }
    } catch (err) {
      console.error("Error loading content:", err);
    }
  };

  // ✅ Called when user types / edits
  onEditorStateChange = (editorState) => {
    this.isInternalChange = true; // mark as user input

    const content = editorState.getCurrentContent();
    const html = draftToHtml(convertToRaw(content));

    this.setState({ editorState, lastHtml: html });

    // 🔥 Debounced Formik or external sync (prevents jump)
    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => {
      if (this.props.setFieldValue && this.props.name) {
        this.props.setFieldValue(this.props.name, html);
      }
      if (this.props.onChange) {
        this.props.onChange({ html });
      }
      this.isInternalChange = false; // reset flag after sync
    }, 300);
  };

  componentWillUnmount() {
    clearTimeout(this.debounceTimer);
  }

  render() {
    const { editorState } = this.state;
    const { placeholder } = this.props;

    return (
      <div className="editor-container">
        <Editor
          editorState={editorState}
          onEditorStateChange={this.onEditorStateChange}
          wrapperClassName="wrapper"
          editorClassName="editor border p-2 rounded bg-white"
          handlePastedText={() => "not-handled"}
          stripPastedStyles={false}
          toolbarClassName="toolbar-class hide-toolbar"
          placeholder={placeholder || "Type your text here..."}
          toolbar={{
            options: [
              "list",
              "textAlign",
              "link"
            ],
          }}
        />
      </div>
    );
  }
}

EmailContentEditor.propTypes = {
  initialContent: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  setFieldValue: PropTypes.func,
  name: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
};

export default EmailContentEditor;
